/* eslint-disable no-console */
import React, { Suspense } from 'react';
import Loader from '../Block/common/Loading/Loading';
import Lti, { checkLtiSession } from './Lti';
import Cognito, { checkCognitoSession } from './Cognito';
import Offline, { checkOfflineSession } from './Offline';

// placeholder for sessionCheck function
let checkSession = async () => {
  return Promise.resolve(true);
};

if (
  process.env.NODE_ENV === 'development' &&
  process.env.REACT_APP_TEST_SECURITY === 'true'
) {
  if (process.env.REACT_APP_SECURITY === 'lti') {
    // if in LTI mode, assign checkLtiSession
    checkSession = checkLtiSession;
  }

  if (process.env.REACT_APP_SECURITY === 'cognito') {
    // if in Cogito mode, assign checkCognitoSession
    checkSession = checkCognitoSession;
  }

  if (process.env.REACT_APP_SECURITY === 'offline') {
    // if in Offline mode, assign checkOfflineSession
    checkSession = checkOfflineSession;
  }
}

// export the function to be used in CourseActions.js
export { checkSession };

const Security = ({ children }) => {
  // dev env
  if (
    process.env.NODE_ENV === 'development' &&
    process.env.REACT_APP_TEST_SECURITY !== 'true'
  ) {
    return children;
  }
  // congnito security
  if (process.env.REACT_APP_SECURITY === 'cognito') {
    return (
      <Suspense fallback={<Loader context="Security" />}>
        <Cognito cognito app={children} />;
      </Suspense>
    );
  }
  // LTI security
  if (process.env.REACT_APP_SECURITY === 'lti') {
    return (
      <Suspense fallback={<Loader context="Security" />}>
        <Lti app={children} />
      </Suspense>
    );
  }
  // Offline security
  if (process.env.REACT_APP_SECURITY === 'offline') {
    return (
      <Suspense fallback={<Loader context="Security" />}>
        <Offline app={children} />
      </Suspense>
    );
  }
  // no security
  return children;
};

export default Security;
